import { CheckCircle2, AlertCircle } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const Field = ({ id, label, required, hint, children }) => (
  <div>
    <label htmlFor={id} className="lbl block text-ink">
      {label}{required && <span aria-hidden="true" className="text-teal"> *</span>}
      {!required && <span className="normal-case tracking-normal font-normal text-slate"> (optional)</span>}
    </label>
    {children}
    {hint && <p className="mt-1 font-sans text-sm text-slate" id={`${id}-hint`}>{hint}</p>}
  </div>
);

export const TextInput = ({ id, ...props }) => <input id={id} name={id} className="field font-sans" data-testid={`${id}-input`} {...props} />;

export const TextArea = ({ id, ...props }) => <textarea id={id} name={id} className="field font-sans resize-y" data-testid={`${id}-input`} {...props} />;

export const Choice = ({ id, value, onChange, options, placeholder = "Choose one", required }) => (
  <Select value={value} onValueChange={onChange} required={required}>
    <SelectTrigger id={id} className="field font-sans text-[17px] h-auto rounded-none shadow-none border-x-0 border-t-0 focus:ring-0" data-testid={`${id}-select`}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="bg-paper font-sans">
      {options.map((o) => (
        <SelectItem key={o} value={o} data-testid={`${id}-option-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{o}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

// Hidden honeypot field to deter bots
export const Honeypot = ({ value, onChange }) => (
  <div aria-hidden="true" className="hidden">
    <label htmlFor="website">Website</label>
    <input id="website" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} />
  </div>
);

export const FormStatus = ({ status, testid }) => {
  if (!status) return <div role="status" aria-live="polite" />;
  const ok = status.type === "success";
  const Icon = ok ? CheckCircle2 : AlertCircle;
  return (
    <div
      role={ok ? "status" : "alert"}
      aria-live="polite"
      data-testid={testid}
      className={`flex gap-3 items-start rounded-2xl p-5 font-sans ${ok ? "bg-paper border-2 border-teal text-ink" : "bg-paper border-2 border-destructive text-destructive"}`}
    >
      <Icon className={`w-6 h-6 shrink-0 ${ok ? "text-teal" : ""}`} aria-hidden="true" />
      <div>
        <p className="font-semibold">{status.title}</p>
        <p className="mt-1 text-[15px] text-ink">{status.text}</p>
      </div>
    </div>
  );
};
